module.exports = __webpack_public_path__ + "css/OceanVolt.02be99bf.css";